import styled from '@emotion/styled';
import { useContentLists } from '@innovamat/glow-api-client';
import { MarkSessionMethodParams } from '../../../session-done';
import { ContentList, ContentListSkeleton } from '../../components';
import { ContentListType, ContentResource } from '../../types';

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

type IRelatedResourcesListProps = {
  linkedListsIds: string[];
  classroomId: string;
  academicYearId: string;
  onResourceClick: (resource: ContentResource, list: ContentListType) => void;
  onMarkSession?: (params: MarkSessionMethodParams) => void;
  onToggleSolutions?: (params: MarkSessionMethodParams) => void;
  isStudentView?: boolean;
  language: string;
  region: string;
};

export function LinkedListsPage({
  linkedListsIds,
  onResourceClick,
  onMarkSession,
  onToggleSolutions,
  classroomId,
  academicYearId,
  isStudentView,
  region,
  language,
}: IRelatedResourcesListProps) {
  const { data, isLoading } = useContentLists({
    academicYearId,
    classroomId: classroomId!,
    contentListsIds: linkedListsIds,
    isStudentView: Boolean(isStudentView),
    region,
    language,
  });

  const contentLists = data;

  if (isLoading) {
    return (
      <SkeletonContainer>
        <ContentListSkeleton />
        <ContentListSkeleton />
      </SkeletonContainer>
    );
  }

  return (
    <Container>
      {contentLists?.map((list, index) => {
        return (
          <ContentList
            academicYearId={academicYearId}
            classroomId={classroomId}
            key={index}
            list={list}
            onResourceClick={(resource) => onResourceClick(resource, list)}
            onMarkSession={onMarkSession}
            onToggleSolutions={onToggleSolutions}
          />
        );
      })}
    </Container>
  );
}
